import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

/**
 * Deletes a saved filter.
 *
 * @param savedFilterId - The saved-filter ID to delete.
 * @param options - Optional ky request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/User/operation/delete_saved_filter_user_saved_filters__saved_filter_id__delete
 */
export const deleteSavedFilter = async (
  savedFilterId: UUID,
  options?: KyRequestOptions,
): Promise<void> => {
  await vestigasApi.delete(ENDPOINT.USER.SAVED_FILTER(savedFilterId), options);
};
